export default __webpack_public_path__ + "static/media/Indinoir.230af3f3.png";